<template>
  <button type="button" :class="btnClass" @click="showRoleModal">
    <FileEarmarkPlusIcon />
    {{ i18n('Add New') }}
  </button>

  <RoleModal ref="RoleModal" @created="$emit('created', $event)" />
</template>
<script>
import RoleModal from "@/components/role/RoleModal.vue";
import FileEarmarkPlusIcon from "@/assets/svg/file-earmark-plus.vue";

export default {
  components: {
    RoleModal,
    FileEarmarkPlusIcon,
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-outline-light',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'added',
    'created'
  ],
  methods: {
    showRoleModal() {
      this.$refs['RoleModal'].show();
    },
  }
};
</script>